/* 🤖 this file was generated by svg-to-ts */
export const matIconUpgrade: {
  name: 'upgrade';
  data: string;
} = {
  name: 'upgrade',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 18v2H8v-2h8zM11 7.99V16h2V7.99h3L12 4 8 7.99h3z"/></svg>`
};
